    <mat-toolbar color="primary" class="app-header">
      <button mat-icon-button routerLink="/" class="header-menu-btn">
        <mat-icon>directions_car</mat-icon>
      </button>
      <span class="header-title">AvtoTime</span>
      <span class="header-spacer"></span>
      <span class="header-user" *ngIf="userName">{{ userName }}</span>
      <button mat-icon-button (click)="logout()" *ngIf="authService.currentUser$ | async" 
              aria-label="Выйти" class="header-logout-btn">
        <mat-icon>logout</mat-icon>
      </button>
    </mat-toolbar>
  
